/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewReportEntry } from '../models/new-report-entry';
import { ReportEntry } from '../models/report-entry';
import { ReportEntryDto } from '../models/report-entry-dto';
import { ReportEntryUpdateById } from '../models/report-entry-update-by-id';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class ReportEntryControllerService extends DataBaseService {

  /**
   * Path part for operation reportEntryControllerCount
   */
  static readonly ReportEntryControllerCountPath = '/v1/reports/count';

  /**
   * Get report entry count
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get report entry count
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation reportEntryControllerExecuteReportCount
   */
  static readonly ReportEntryControllerExecuteReportCountPath = '/v1/reports/{id}/entries/count';

  /**
   * Get records count for the report execution
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeReportCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReportCount$Response(params: {
    id: string;
    where?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerExecuteReportCountPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get records count for the report execution
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeReportCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReportCount(params: {
    id: string;
    where?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.executeReportCount$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation reportEntryControllerExecuteReport
   */
  static readonly ReportEntryControllerExecuteReportPath = '/v1/reports/{id}/entries';

  /**
   * Execute Report and returns the result as DataEntry[]
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReport$Response(params: {
    id: string;
    filter?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ReportEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerExecuteReportPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReportEntry>>;
      })
    );
  }
  /**
   * Execute Report and returns the result as DataEntry[]
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReport(params: {
    id: string;
    filter?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ReportEntry>> {

    return this.executeReport$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReportEntry>>) => r.body as Array<ReportEntry>)
    );
  }

  /**
   * Path part for operation reportEntryControllerFindById
   */
  static readonly ReportEntryControllerFindByIdPath = '/v1/reports/{id}';

  /**
   * Get report by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<ReportEntryDto>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReportEntryDto>;
      })
    );
  }
  /**
   * Get report by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<ReportEntryDto> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<ReportEntryDto>) => r.body as ReportEntryDto)
    );
  }

  /**
   * Path part for operation reportEntryControllerDeleteById
   */
  static readonly ReportEntryControllerDeleteByIdPath = '/v1/reports/{id}';

  /**
   * Delete report with id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete report with id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reportEntryControllerUpdateById
   */
  static readonly ReportEntryControllerUpdateByIdPath = '/v1/reports/{id}';

  /**
   * Update report entry by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ReportEntryUpdateById
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update report entry by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ReportEntryUpdateById
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reportEntryControllerFind
   */
  static readonly ReportEntryControllerFindPath = '/v1/reports';

  /**
   * Get all reports defined in the system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ReportEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReportEntry>>;
      })
    );
  }
  /**
   * Get all reports defined in the system
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ReportEntry>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReportEntry>>) => r.body as Array<ReportEntry>)
    );
  }

  /**
   * Path part for operation reportEntryControllerCreate
   */
  static readonly ReportEntryControllerCreatePath = '/v1/reports';

  /**
   * Create a new report
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewReportEntry
  }): Observable<StrictHttpResponse<ReportEntryDto>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReportEntryDto>;
      })
    );
  }
  /**
   * Create a new report
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewReportEntry
  }): Observable<ReportEntryDto> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ReportEntryDto>) => r.body as ReportEntryDto)
    );
  }

  /**
   * Path part for operation reportEntryControllerExecuteReportCountV2
   */
  static readonly ReportEntryControllerExecuteReportCountV2Path = '/v2/reports/{id}/entries/count';

  /**
   * Get records count for the report execution
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeReportCountV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReportCountV2$Response(params: {
    id: string;
    whereCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerExecuteReportCountV2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('whereCriteria', params.whereCriteria, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get records count for the report execution
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeReportCountV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReportCountV2(params: {
    id: string;
    whereCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.executeReportCountV2$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation reportEntryControllerExecuteReportV2
   */
  static readonly ReportEntryControllerExecuteReportV2Path = '/v2/reports/{id}/entries';

  /**
   * Execute Report and returns the result as DataEntry[]
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeReportV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReportV2$Response(params: {
    id: string;
    filterCriteria?: any;
    include_virtual?: boolean;
    search?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ReportEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerExecuteReportV2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('search', params.search, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReportEntry>>;
      })
    );
  }
  /**
   * Execute Report and returns the result as DataEntry[]
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeReportV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeReportV2(params: {
    id: string;
    filterCriteria?: any;
    include_virtual?: boolean;
    search?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ReportEntry>> {

    return this.executeReportV2$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReportEntry>>) => r.body as Array<ReportEntry>)
    );
  }

  /**
   * Path part for operation reportEntryControllerExportReportV2
   */
  static readonly ReportEntryControllerExportReportV2Path = '/v2/reports/{id}/export/{format}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportReportV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response(params: {
    id: string;
    format: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    selectedColumns?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerExportReportV2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('format', params.format, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('selectedColumns', params.selectedColumns, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportReportV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet(params: {
    id: string;
    format: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    selectedColumns?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.exportReportV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportReportV2$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportV2$Pdf$Response(params: {
    id: string;
    format: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    selectedColumns?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ReportEntryControllerService.ReportEntryControllerExportReportV2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('format', params.format, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('selectedColumns', params.selectedColumns, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportReportV2$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportV2$Pdf(params: {
    id: string;
    format: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    selectedColumns?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.exportReportV2$Pdf$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
